import { Inject, Injectable } from '@angular/core';
import {
  ApiService,
  AuthService,
  EnvironmentService,
  HttpRequestService,
  LogService,
  NotificationService,
  PagedResultGeneric,
  UtilService,
} from 'src/app/shared';
import { ServiceApiService } from 'src/app/shared/api/service-api.service';
import { EComItemTypeCustomFieldSearchDto } from './dto/ecom-item-type-custom-field-search.dto';
import { EComItemTypeCustomFieldDto } from './dto/ecom-item-type-custom-field.dto';

@Injectable({
  providedIn: 'root',
})
export class EcomItemTypeCustomFieldService extends ServiceApiService {
  constructor(
    @Inject(AuthService) authService: AuthService,
    @Inject(UtilService) utilService: UtilService,
    @Inject(LogService) logService: LogService,
    @Inject(HttpRequestService) httpRequestService: HttpRequestService,
    @Inject(EnvironmentService) environmentService: EnvironmentService,
    @Inject(NotificationService) notificationService: NotificationService
  ) {
    super(authService, utilService, logService, httpRequestService, environmentService, notificationService, 'eCommerce');
  }

  public search(searchDto: EComItemTypeCustomFieldSearchDto): Promise<PagedResultGeneric<EComItemTypeCustomFieldDto>> {
    let url = `ecommerce/v2/customfields`;
    return this.post(url, searchDto);
  }

  public getEcomItemTypeCustomField(id: number): Promise<EComItemTypeCustomFieldDto> {
    let url = `ecommerce/v2/customfield/${id}`;
    return this.get(url);
  }

  createItemType(dto: EComItemTypeCustomFieldDto): Promise<number> {
    return this.post('ecommerce/v2/customfield', dto);
  }

  updateItemType(id: number, dto: EComItemTypeCustomFieldDto): Promise<void> {
    return this.put(`ecommerce/v2/customfield/${id}`, dto);
  }

  public deleteEcomItemTypeCustomField(id: number): Promise<void> {
    let url = `ecommerce/v2/customfield/${id}`;
    return this.delete(url);
  }
}
